import { render, staticRenderFns } from "./AddPurchaseInvoice.vue?vue&type=template&id=b36a0c70&scoped=true&"
import script from "./AddPurchaseInvoice.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddPurchaseInvoice.vue?vue&type=style&index=0&id=b36a0c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36a0c70",
  null
  
)

export default component.exports